/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DeliveryAddressRequest,
  DeliveryAddressResponse,
  DeliveryAddressSearchRequest,
  DeliveryAddressSearchResponse,
  PageResponsePickupOrderResponse,
  PageResponseShipmentResponse,
  PickupOrderResponse,
  PickupOrderSearchRequest,
  PickupOrderShipment,
  PickupOrderTracking,
  PickupPointView,
  PlacePickupOrderRequest,
  ShipmentResponse,
  ShipmentSearchRequest,
  ShipmentTrackingEventResponse,
  TariffPreviewRequest,
  TariffQuote,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Shipping<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags delivery-address-controller
   * @name GetDeliveryAddress
   * @summary One delivery address
   * @request GET:/shipping/delivery-addresses/{id}
   * @secure
   * @response `200` `DeliveryAddressResponse` OK
   */
  getDeliveryAddress = (id: string, params: RequestParams = {}) =>
    this.request<DeliveryAddressResponse, any>({
      path: `/shipping/delivery-addresses/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags delivery-address-controller
   * @name UpdateDeliveryAddress
   * @summary Update a delivery address
   * @request PUT:/shipping/delivery-addresses/{id}
   * @secure
   * @response `200` `DeliveryAddressResponse` OK
   */
  updateDeliveryAddress = (
    id: string,
    data: DeliveryAddressRequest,
    params: RequestParams = {},
  ) =>
    this.request<DeliveryAddressResponse, any>({
      path: `/shipping/delivery-addresses/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags delivery-address-controller
   * @name ArchiveDeliveryAddress
   * @summary Archive a delivery address — never deleted
   * @request DELETE:/shipping/delivery-addresses/{id}
   * @secure
   * @response `200` `void` OK
   */
  archiveDeliveryAddress = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/shipping/delivery-addresses/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name SearchShipments
   * @summary Paged, filtered shipment list
   * @request POST:/shipping/shipments/search
   * @secure
   * @response `200` `PageResponseShipmentResponse` OK
   */
  searchShipments = (data: ShipmentSearchRequest, params: RequestParams = {}) =>
    this.request<PageResponseShipmentResponse, any>({
      path: `/shipping/shipments/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name PreviewShipmentTariff
   * @summary Tariff preview, no side effects
   * @request POST:/shipping/shipments/preview
   * @secure
   * @response `200` `TariffQuote` OK
   */
  previewShipmentTariff = (
    data: TariffPreviewRequest,
    params: RequestParams = {},
  ) =>
    this.request<TariffQuote, any>({
      path: `/shipping/shipments/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-point-controller
   * @name MarkPickupPointDefault
   * @summary Make this the default sender
   * @request POST:/shipping/pickup-points/{id}/default
   * @secure
   * @response `200` `PickupPointView` OK
   */
  markPickupPointDefault = (id: string, params: RequestParams = {}) =>
    this.request<PickupPointView, any>({
      path: `/shipping/pickup-points/${id}/default`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-point-controller
   * @name SyncPickupPoints
   * @summary Force-refresh the pickup point mirror from the courier
   * @request POST:/shipping/pickup-points/sync
   * @secure
   * @response `200` `Record<string,number>` OK
   */
  syncPickupPoints = (params: RequestParams = {}) =>
    this.request<Record<string, number>, any>({
      path: `/shipping/pickup-points/sync`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name PlacePickupOrder
   * @summary Order a courier for one sender and date
   * @request POST:/shipping/pickup-orders
   * @secure
   * @response `200` `PickupOrderResponse` OK
   */
  placePickupOrder = (
    data: PlacePickupOrderRequest,
    params: RequestParams = {},
  ) =>
    this.request<PickupOrderResponse, any>({
      path: `/shipping/pickup-orders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name SearchPickupOrders
   * @summary Paged, filtered courier order history
   * @request POST:/shipping/pickup-orders/search
   * @secure
   * @response `200` `PageResponsePickupOrderResponse` OK
   */
  searchPickupOrders = (
    data: PickupOrderSearchRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponsePickupOrderResponse, any>({
      path: `/shipping/pickup-orders/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags delivery-address-controller
   * @name CreateDeliveryAddress
   * @summary Save a delivery address
   * @request POST:/shipping/delivery-addresses
   * @secure
   * @response `200` `DeliveryAddressResponse` OK
   */
  createDeliveryAddress = (
    data: DeliveryAddressRequest,
    params: RequestParams = {},
  ) =>
    this.request<DeliveryAddressResponse, any>({
      path: `/shipping/delivery-addresses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags delivery-address-controller
   * @name SearchDeliveryAddresses
   * @summary Paged, filtered delivery address book
   * @request POST:/shipping/delivery-addresses/search
   * @secure
   * @response `200` `DeliveryAddressSearchResponse` OK
   */
  searchDeliveryAddresses = (
    data: DeliveryAddressSearchRequest,
    params: RequestParams = {},
  ) =>
    this.request<DeliveryAddressSearchResponse, any>({
      path: `/shipping/delivery-addresses/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name GetShipment
   * @summary One shipment, full detail
   * @request GET:/shipping/shipments/{id}
   * @secure
   * @response `200` `ShipmentResponse` OK
   */
  getShipment = (id: string, params: RequestParams = {}) =>
    this.request<ShipmentResponse, any>({
      path: `/shipping/shipments/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name VoidShipment
   * @summary Void an AWB and clear it from the task
   * @request DELETE:/shipping/shipments/{id}
   * @secure
   * @response `200` `ShipmentResponse` OK
   */
  voidShipment = (
    id: string,
    query?: {
      reason?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ShipmentResponse, any>({
      path: `/shipping/shipments/${id}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name GetShipmentTracking
   * @summary The parcel's event history, newest first
   * @request GET:/shipping/shipments/{id}/tracking
   * @secure
   * @response `200` `(ShipmentTrackingEventResponse)[]` OK
   */
  getShipmentTracking = (id: string, params: RequestParams = {}) =>
    this.request<ShipmentTrackingEventResponse[], any>({
      path: `/shipping/shipments/${id}/tracking`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags shipment-controller
   * @name GetShipmentLabel
   * @summary The AWB label PDF
   * @request GET:/shipping/shipments/{id}/label
   * @secure
   * @response `200` `Blob` OK
   */
  getShipmentLabel = (id: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/shipping/shipments/${id}/label`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-point-controller
   * @name ListPickupPoints
   * @summary Our sender branches registered at the courier
   * @request GET:/shipping/pickup-points
   * @secure
   * @response `200` `(PickupPointView)[]` OK
   */
  listPickupPoints = (params: RequestParams = {}) =>
    this.request<PickupPointView[], any>({
      path: `/shipping/pickup-points`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-point-controller
   * @name GetPickupPoint
   * @summary One pickup point
   * @request GET:/shipping/pickup-points/{id}
   * @secure
   * @response `200` `PickupPointView` OK
   */
  getPickupPoint = (id: string, params: RequestParams = {}) =>
    this.request<PickupPointView, any>({
      path: `/shipping/pickup-points/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name GetPickupOrder
   * @summary One courier order with its AWBs
   * @request GET:/shipping/pickup-orders/{id}
   * @secure
   * @response `200` `PickupOrderResponse` OK
   */
  getPickupOrder = (id: string, params: RequestParams = {}) =>
    this.request<PickupOrderResponse, any>({
      path: `/shipping/pickup-orders/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name CancelPickupOrder
   * @summary Cancel a courier order and free its AWBs
   * @request DELETE:/shipping/pickup-orders/{id}
   * @secure
   * @response `200` `PickupOrderResponse` OK
   */
  cancelPickupOrder = (id: string, params: RequestParams = {}) =>
    this.request<PickupOrderResponse, any>({
      path: `/shipping/pickup-orders/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name GetPickupOrderTracking
   * @summary The courier's own view of the order
   * @request GET:/shipping/pickup-orders/{id}/tracking
   * @secure
   * @response `200` `PickupOrderTracking` OK
   */
  getPickupOrderTracking = (id: string, params: RequestParams = {}) =>
    this.request<PickupOrderTracking, any>({
      path: `/shipping/pickup-orders/${id}/tracking`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name GetPickupOrderShipments
   * @summary Just the AWBs in a courier order
   * @request GET:/shipping/pickup-orders/{id}/shipments
   * @secure
   * @response `200` `(PickupOrderShipment)[]` OK
   */
  getPickupOrderShipments = (id: string, params: RequestParams = {}) =>
    this.request<PickupOrderShipment[], any>({
      path: `/shipping/pickup-orders/${id}/shipments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags pickup-order-controller
   * @name ListPendingPickups
   * @summary AWBs waiting for a courier, grouped by sender and date
   * @request GET:/shipping/pickup-orders/pending
   * @secure
   * @response `200` `(PickupOrderResponse)[]` OK
   */
  listPendingPickups = (params: RequestParams = {}) =>
    this.request<PickupOrderResponse[], any>({
      path: `/shipping/pickup-orders/pending`,
      method: "GET",
      secure: true,
      ...params,
    });
}
